import React, { useState } from 'react';

const linkBtnStyle = { background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', color: 'inherit', padding: 0 };

function BookingHeader({ step = 0, guestInfo, onAccountClick, onSignInClick, onGiftCardClick, onPackagesClick, onBookClick, onReferralsClick }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const inFlow = step >= 1 && step <= 10;
  const close = (fn) => () => { setMenuOpen(false); fn(); };

  return (
    <header className={`booking-header${inFlow ? ' booking-header--collapsed' : ''}`}>
      <a href="https://cutiepiewaxbar.com" style={{display:'flex',alignItems:'center',textDecoration:'none'}}>
        <img src="/logo.png" alt="Cutie Pie Wax Bar" className={`logo${inFlow ? ' logo--compact' : ''}`} onError={(e) => e.target.style.display = 'none'} />
      </a>
      <nav className="header-nav">
        <button className="nav-link active" onClick={onBookClick} style={linkBtnStyle}>BOOK</button>
        <button className="nav-link" onClick={onGiftCardClick} style={linkBtnStyle}>GIFT CARDS</button>
        <button className="nav-link" onClick={onPackagesClick} style={linkBtnStyle}>PACKAGES</button>
        <button className="nav-link" onClick={onReferralsClick} style={linkBtnStyle}>REFERRALS</button>
        {guestInfo ? (
          <button className="nav-avatar" onClick={onAccountClick} title="My Account">
            {(guestInfo.firstName || guestInfo.first_name || '?')[0].toUpperCase()}
          </button>
        ) : (
          <button className="nav-link" onClick={onSignInClick} style={linkBtnStyle}>
            SIGN IN
          </button>
        )}
      </nav>
      <button
        className={`hamburger-btn${menuOpen ? ' open' : ''}`}
        aria-label="Menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(o => !o)}
      >
        <span></span><span></span><span></span>
      </button>
      <div className={`hamburger-menu${menuOpen ? ' open' : ''}`}>
        <button className="nav-link" onClick={close(onBookClick)} style={linkBtnStyle}>BOOK</button>
        <button className="nav-link" onClick={close(onGiftCardClick)} style={linkBtnStyle}>GIFT CARDS</button>
        <button className="nav-link" onClick={close(onPackagesClick)} style={linkBtnStyle}>PACKAGES</button>
        <button className="nav-link" onClick={close(onReferralsClick)} style={linkBtnStyle}>REFERRALS</button>
        {guestInfo ? (
          <button className="nav-link" onClick={close(onAccountClick)} style={linkBtnStyle}>MY ACCOUNT</button>
        ) : (
          <button className="nav-link" onClick={close(onSignInClick)} style={linkBtnStyle}>SIGN IN</button>
        )}
      </div>
    </header>
  );
}

export default BookingHeader;
